import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import * as noteValues from '@src/slide/application/service/menu-manager/menu-values/note';
import * as groupValues from '@src/slide/application/service/menu-manager/menu-values/group';
import * as multiplyValues from '@src/slide/application/service/menu-manager/menu-values/multiply';
import { elementModelsTypes, getElementMenuValues } from './element-menu-values-getter';

/**
 * 获取uiModel对应的菜单值
 * @param model
 */
export function getMenuValues(model?: IBaseModel | INoteModel): { [key: string]: any } {
    if (!model) {
        return {};
    }
    if (elementModelsTypes.includes(model.type)) {
        return getElementMenuValues(model);
    }
    // 备注
    if ([UIModelType.NOTE].includes(model.type)) {
        return noteValues.getMenuValues(model as INoteModel);
    }
    // 组合
    if ([UIModelType.GROUP].includes(model.type)) {
        return groupValues.getMenuValues(model as IGroupModel);
    }
    // 多选
    if ([UIModelType.MULTIPLY].includes(model.type)) {
        return multiplyValues.getMenuValues(model as IMultiplyModel);
    }
    return {};
}
